import { AnnotationShape } from '../../typings/common';
import { NotificationResult, ValidatorColor } from '../../typings/notification';
import { ResolutionValue } from '../configuration';

export const resolutionValidator = (
  validatorConfiguration: string,
  shape: AnnotationShape,
  printPositionName: string
): NotificationResult | undefined => {
  const validatorName = 'resolutionValidator';
  const resolutionColorsValues: ResolutionValue[] = JSON.parse(
    validatorConfiguration
  );

  resolutionColorsValues.sort((a, b) => b.maxDPI - a.maxDPI);
  if (shape.kind === 'Logo') {
    const { pngHorizontalResolutionDPIs, pngVerticalResolutionDPIs } = shape;

    const lowerDPI = Math.round(
      pngHorizontalResolutionDPIs <= pngVerticalResolutionDPIs
        ? pngHorizontalResolutionDPIs
        : pngVerticalResolutionDPIs
    );
    const higherDPI = Math.round(
      pngHorizontalResolutionDPIs >= pngVerticalResolutionDPIs
        ? pngHorizontalResolutionDPIs
        : pngVerticalResolutionDPIs
    );
    let color: ValidatorColor = 'Green';
    const rangeMaxDpi = resolutionColorsValues[0].maxDPI;
    if (higherDPI > rangeMaxDpi) {
      color = 'Red';
      return {
        shapeId: shape.id,
        printPositionName,
        validatorName,
        validatorColor: color,
        message: resolutionColorsValues[0].minDPI.toString(),
      };
    }

    for (const range of resolutionColorsValues) {
      if (lowerDPI >= range.minDPI && lowerDPI <= range.maxDPI) {
        color = convertRangeToColor(range);
        return {
          shapeId: shape.id,
          printPositionName,
          validatorName,
          validatorColor: color,
          message: resolutionColorsValues[0].minDPI.toString(),
        };
      }
    }

    return {
      shapeId: shape.id,
      printPositionName,
      validatorName,
      validatorColor: color,
      message: resolutionColorsValues[0].minDPI.toString(),
    };
  }
};

const convertRangeToColor = (range: ResolutionValue): ValidatorColor => {
  if (range.color.toLowerCase() === 'red') {
    return 'Red';
  }

  if (range.color.toLowerCase() === 'green') {
    return 'Green';
  }

  if (range.color.toLowerCase() === 'orange') {
    return 'Orange';
  }

  return 'Green';
};
